<template lang='pug'>
v-layout(class='list' row wrap)
  v-flex(xs12)
    v-layout(row wrap)
      v-flex(xs12 sm8)
        div(class='headline font-weight-bold') {{ company.name }}
        div(class='my-3')
          div(class='grey--text') Руководитель
          div(class='subheading font-weight-medium') {{ company.director }}
        div(class='my-3')
          div(class='grey--text') Контактная информация
          div(class='subheading font-weight-medium') {{ company.address_full }}
        div(class='my-3')
          div(class='grey--text') Сайт управляющей компании
          div(class='subheading font-weight-medium')
            a(:href='company.site' style='color: black' target='_blank') {{ company.site }}
        div(class='my-3')
          div(class='grey--text') Контактные телефоны
          div(class='subheading font-weight-medium')
            div(v-for='(contact, index) in contacts' :key='index') {{ contact | phone }}
      v-flex(xs12 sm4)
        v-img(:src='company.avatar_url' class='logo mb-5')
    v-divider
    div(class='subheading my-3')
      rhtml(:html='company.about')
    v-divider
    images(:images='step.images')
</template>

<script>
import Html from './Html'
import Images from './Images'

export default {
  props: ['step'],

  components: {
    Rhtml: Html,
    Images
  },

  computed: {
    company() {
      let { management_company } = this.step.step_info
      return management_company
    },

    contacts() {
      return this.company.contacts.split(/,/)
    }
  }
}
</script>

<style scoped>
.logo {
  width: 100%;
}
</style>
